export class ShowLoginPanel {
    static readonly type = '[UI] ShowLoginPanel';
}

export class HideLoginPanel {
    static readonly type = '[UI] HideLoginPanel';
}
